import { BreakpointKey, getBreakpointValue } from 'styles/theme/breakpoints'

/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 */
export function responsiveProperty({
  cssProperty,
  min,
  max,
  unit = 'rem',
  breakpoints = [600, 960, 1280],
}: {
  cssProperty: string
  min: number
  max: number
  unit?: string
  breakpoints?: number[]
}) {
  const factor = (max - min) / breakpoints[breakpoints.length - 1]

  return breakpoints.reduce(
    (acc, breakpoint) => {
      const value = min + factor * breakpoint
      return {
        ...acc,
        [`@media (min-width:${breakpoint}px)`]: {
          [cssProperty]: `${Math.round(value * 1000) / 1000}${unit}`,
        },
      }
    },
    {
      [cssProperty]: `${min}${unit}`,
    } as any,
  )
}

export function responsiveFontSize(
  remFontSize: string | number,
  {
    factor = 3,
    breakpoints = ['mobileL', 'tabletS', 'tablet', 'tabletL', 'laptopM'] as BreakpointKey[],
    unit = 'rem',
  } = {},
) {
  const maxFontSize = typeof remFontSize !== 'number' ? parseFloat(remFontSize) : remFontSize
  const minFontSize = 1 + (maxFontSize - 1) / factor
  return responsiveProperty({
    max: maxFontSize,
    min: minFontSize,
    cssProperty: 'fontSize',
    breakpoints: breakpoints.map(getBreakpointValue),
    unit,
  })
}
